import React from 'react';

export function Call() {
    return <div>
        <h2>Call</h2>
        </div>;
}